var ApproveListController = (function () {
    function ApproveListController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.clientsLoaded = false;
        this.importingExcel = false;
        this.exportFired = false;
        this.isSaving = false;
        this.processing = true;
        this.clientItems = [];
        this.docTable = [];
        this.historyInfo = {};
        this.backendModuleName = 'admin/approvedlist/approved-list';
        this.scopePrefix = 'admin.approvedList';
        this.scopeGetData = this.scopePrefix + ".query";
        this.scopeGetLogs = this.scopePrefix + ".logs";
        this.scopeUpdateLogs = this.scopePrefix + ".logsUpdate";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeExportTemplate = this.scopePrefix + ".exportTemplate";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        this.historyTable = {
            instance: {}
        };
        this.historyInfo = {
            bpCeidInfo: '',
            customerNumberInfo: ''
        };
        this.historyTable.options = this.DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption('searchDelay', 350)
            .withOption('alphabetColumnIndex', 2);
        this.historyTable.columnDefs = [];
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (data.payload.logs) {
                _this.docTable = data.payload.logs.reverse();
            }
        });
        //UPDATED HISTORY
        this.socket.forward(this.scopeUpdateLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateLogs, function (event, data) {
            _this.getHistory();
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            _this.isSaving = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update record');
                return _this.notify.error("Unable to update record");
            }
            else {
                _this.notify.success('Client list updated successful!');
                _this.sendNewHistoryLog('Edited record');
                return _this.initFunction();
            }
        });
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create record');
                return _this.notify.error("Unable to create record");
            }
            else {
                _this.notify.success('Client was added successful!');
                _this.sendNewHistoryLog('Created record');
                return _this.initFunction();
            }
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                return _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.sendNewHistoryLog('Deleted record');
                return _this.initFunction();
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                return _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.sendNewHistoryLog('Deleted all records');
                return _this.initFunction();
            }
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-NEW-APPROVED-CLIENTS');
                return _this.notify.success('New clients list was exported successful!');
            }
        });
        // DOWNLOAD EXCEL TEMPLATE
        this.socket.forward(this.scopeExportTemplate, this.$scope);
        this.$scope.$on("socket:" + this.scopeExportTemplate, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting template');
                return _this.notify.error("Can't to export latest template");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-NEW-APPROVED-CLIENTS-template');
                return _this.notify.success('New clients list latest template downloaded successful!');
            }
        });
        // UPLOADADED
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and added. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
        // UPLOAD REPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.sendNewHistoryLog("Upload from .xlsx and replaced. Count of inserted records: " + data.payload);
                return _this.initFunction();
            }
        });
    }
    ApproveListController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 3)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[3, 'asc']]) // Default sorting by BP name
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.getHistory();
    };
    ApproveListController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/approved-list',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.clientsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.clientItems = data.data;
                _this.clientsLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve New Client Approved list data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.clientsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    ApproveListController.prototype.buildColumns = function () {
        var _this = this;
        var DATE_FORMAT = 'd MMM yyyy';
        return [
            this.DTColumnBuilder.newColumn('IOT').notSortable()
                .withOption('name', 'IOT').withTitle('IOT'),
            this.DTColumnBuilder.newColumn('IMT').notSortable()
                .withOption('name', 'IMT').withTitle('IMT'),
            this.DTColumnBuilder.newColumn('COUNTRY_NAME').notSortable()
                .withOption('name', 'COUNTRY_NAME').withTitle('Country name'),
            this.DTColumnBuilder.newColumn('BP').notSortable()
                .withOption('name', 'BP').withTitle('BP name'),
            this.DTColumnBuilder.newColumn('BP_CEID').notSortable()
                .withOption('name', 'BP_CEID').withTitle('BP CEID'),
            this.DTColumnBuilder.newColumn('CUSTOMER_NAME').notSortable()
                .withOption('name', 'CUSTOMER_NAME').withTitle('Customer name'),
            this.DTColumnBuilder.newColumn('CUSTOMER_NUMBER').notSortable()
                .withOption('name', 'CUSTOMER_NUMBER').withTitle('Customer number'),
            this.DTColumnBuilder.newColumn('START_DATE').notSortable()
                .withOption('name', 'START_DATE').withTitle('Start date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('APPROVAL_DATE').notSortable()
                .withOption('name', 'APPROVAL_DATE').withTitle('Approval date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('END_DATE').notSortable()
                .withOption('name', 'END_DATE').withTitle('End date').renderWith(function (data) {
                return _this.$filter('date')(new Date(data), DATE_FORMAT);
            }),
            this.DTColumnBuilder.newColumn('OPPORTUNITY_NUMBER').notSortable()
                .withOption('name', 'OPPORTUNITY_NUMBER').withTitle('Opportunity number'),
            this.DTColumnBuilder.newColumn('actions').notSortable()
                .withOption('name', 'actions').withTitle('Actions').renderWith(this.actionButtons)
        ];
    };
    ApproveListController.prototype.actionButtons = function (data, type, full, meta) {
        return "<md-button class=\"edit-button md-button md-ink-ripple\" ng-click=\"vm.editClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to handle all errors
     */
    ApproveListController.prototype.isIncomingErrors = function (data) {
        if (!data || !data.error) {
            return false;
        }
        if (data.error.validationErrors.length || data.error.errors.length) {
            return true;
        }
    };
    /**
     * Function to show all errors
     */
    ApproveListController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    /**
     * Function to download files
     */
    ApproveListController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    /**
     * Function to prepare the DB info for export
     */
    ApproveListController.prototype.exportNewClientPermissions = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to extract country
     */
    ApproveListController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to create new client in DB
     */
    ApproveListController.prototype.createRecord = function (event) {
        var _this = this;
        var tit = 'Add record to existing list';
        var result = this.extractCountry();
        var endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add records to existing list?',
            title: tit,
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            newClient: {
                iot: '-Please select-',
                imt: '-Please select-',
                country: '-Please select-',
                bp: '',
                bp_ceid: '',
                customer_name: '',
                customer_number: '',
                start_date: new Date(),
                end_date: endDate,
                approval_date: new Date(),
                opportunity_number: ''
            },
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, items, 'newclient-insert.html').then(function (answer) {
                    items.newClient = answer.newClient;
                    items.newClient.start_date = items.newClient.start_date.getFullYear() + '-' + (items.newClient.start_date.getMonth() + 1) + '-' + items.newClient.start_date.getDate();
                    items.newClient.end_date = items.newClient.end_date.getFullYear() + '-' + (items.newClient.end_date.getMonth() + 1) + '-' + items.newClient.end_date.getDate();
                    items.newClient.approval_date = items.newClient.approval_date.getFullYear() + '-' + (items.newClient.approval_date.getMonth() + 1) + '-' + items.newClient.approval_date.getDate();
                    items.newClient.country = _this.settings.country_list.filter(function (num) { return num.country === items.newClient.country; })[0].short;
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: items.newClient,
                            function: 'insertRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token,
                            email: _this.env.user.email
                        }
                    });
                    _this.historyInfo.bpCeidInfo = items.newClient.bp_ceid;
                    _this.historyInfo.customerNumberInfo = items.newClient.customer_number;
                });
            }
        });
        return;
    };
    ApproveListController.prototype.getClientById = function (id) {
        return this.clientItems.find(function (cl) { return cl['ID'] === id; });
    };
    /**
     * Function to edit exist client in DB
     */
    ApproveListController.prototype.editClient = function (event, rowId) {
        var _this = this;
        var idx = this.clientItems[rowId].ID;
        var editableClient = this.getClientById(idx);
        var result = this.extractCountry();
        var updatedData = {
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: {
                id: editableClient['ID'],
                iot: editableClient['IOT'],
                imt: editableClient['IMT'],
                country: editableClient['COUNTRY_NAME'],
                bp: editableClient['BP'],
                bp_ceid: editableClient['BP_CEID'],
                customer_name: editableClient['CUSTOMER_NAME'],
                customer_number: editableClient['CUSTOMER_NUMBER'],
                start_date: new Date(editableClient['START_DATE']),
                end_date: new Date(editableClient['END_DATE']),
                approval_date: new Date(editableClient['APPROVAL_DATE']),
                opportunity_number: editableClient['OPPORTUNITY_NUMBER']
            },
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, updatedData, 'client-edit.html').then(function (dResult) {
            updatedData.content.start_date = updatedData.content.start_date.getFullYear() + '-' + (updatedData.content.start_date.getMonth() + 1) + '-' + updatedData.content.start_date.getDate();
            updatedData.content.end_date = updatedData.content.end_date.getFullYear() + '-' + (updatedData.content.end_date.getMonth() + 1) + '-' + updatedData.content.end_date.getDate();
            updatedData.content.approval_date = updatedData.content.approval_date.getFullYear() + '-' + (updatedData.content.approval_date.getMonth() + 1) + '-' + updatedData.content.approval_date.getDate();
            updatedData.content.country = _this.settings.country_list.filter(function (num) { return num.country === updatedData.content.country; })[0].short;
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: updatedData.content,
                    function: 'updateRecord',
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token,
                    email: _this.env.user.email
                }
            });
            _this.historyInfo.bpCeidInfo = updatedData.content.bp_ceid;
            _this.historyInfo.customerNumberInfo = updatedData.content.customer_number;
        });
        return;
    };
    /**
     * Function to delete client in DB
     */
    ApproveListController.prototype.deleteClient = function (event, rowId) {
        var _this = this;
        var idx = this.clientItems[rowId].ID;
        var removableClient = {};
        this.Dialog.confirmDelete(event, idx).then(function (dResult) {
            if (dResult) {
                removableClient = _this.getClientById(idx);
                var deletedData = {
                    id: removableClient['ID']
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
            _this.historyInfo.bpCeidInfo = removableClient['BP_CEID'];
            _this.historyInfo.customerNumberInfo = removableClient['CUSTOMER_NUMBER'];
        });
        return;
    };
    /**
     * Function to delete all clients in DB
     */
    ApproveListController.prototype.deleteAllClients = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload new clients list
     */
    ApproveListController.prototype.uploadNewClientsList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'newclient-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    ApproveListController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    ApproveListController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download clients list template
     */
    ApproveListController.prototype.downloadClientsListTemplate = function (event) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadExcelTemplate',
                scopeBack: this.scopeExportTemplate,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to get all records in DB2
     */
    ApproveListController.prototype.initFunction = function () {
        this.table.dtInstance.DataTable.ajax.reload(null, true);
    };
    /**
     * Function to get all history from Cloudant
     */
    ApproveListController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHistoryLogs',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to send updated history to Cloudant
     */
    ApproveListController.prototype.sendNewHistoryLog = function (operation) {
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            comment: (operation === 'Deleted record' || operation === 'Edited record' || operation === 'Created record') ?
                [(operation + " with bp_ceid: " + this.historyInfo.bpCeidInfo + " and customer number: " + this.historyInfo.customerNumberInfo)] :
                [("" + operation)],
            timestamp: timeText,
            user: this.env.user.email
        };
        this.docTable.reverse().push(oneHist);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateHistoryLogs',
                scopeBack: this.scopeUpdateLogs,
                script: this.backendModuleName,
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTable
            }
        });
    };
    ApproveListController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    ApproveListController.prototype.resetFilters = function () {
        delete this.table.filters;
        this.table.filterParams = {};
    };
    ApproveListController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return ApproveListController;
}());
var ApproveListComponent = (function () {
    function ApproveListComponent() {
        this.templateUrl = 'approved-list.html';
        this.controllerAs = 'vm';
        this.controller = ApproveListController;
    }
    return ApproveListComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon("edit_pen", "/public/icons/ic_mode_edit_black_24px.svg");
})
    .filter("fullDateToFormat", function ($filter) {
    return function (input, format) {
        return $filter("date")(new Date(input), format);
    };
})
    .component('approvedListSection', new ApproveListComponent());

//# sourceMappingURL=approvedlist-view.component.js.map
